import {
  UniFiCategoryId,
  UniFiChildCategorySlug,
} from "@ubnt/store.core/lib/constants/proStoreCategories/mapping/unifi";
import { SiteId } from "@ubnt/store.core/lib/contexts/MenuContext/mapping";
import image from "../../assets/wifi/flagship/u7-pro.png";
import type { Product } from "../../types";
import { wifiFlagship } from "../product-list-groups/wifi-flagship";
import {
  connectedDevices,
  dimensions,
  radio6Ghz,
  uplink,
  wifiCoverage,
  wifiTechnology,
} from "../properties";

export const u7pro: Product = {
  id: "u7pro",
  productTitle: "U7 Pro",
  techspecsPath: [SiteId.TechSpecs, `/unifi/${UniFiCategoryId.WiFi}/u7-pro`],
  storePathParts: {
    productSlug: "u7-pro",
    category: UniFiChildCategorySlug.WiFiFlagship,
  },
  sku: "U7-Pro",
  description: "u7pro.description.1",
  image: { src: image, width: 200, height: 160 },
  productListGroup: wifiFlagship,
  propertyValues: [
    {
      propertyId: wifiTechnology.id,
      value: {
        type: "translation",
        value: "u7pro.wifiTechnology",
      },
    },
    {
      propertyId: dimensions.id,
      value: {
        type: "translation",
        value: "u7pro.dimensions",
      },
    },
    {
      propertyId: radio6Ghz.id,
      value: { type: "boolean", value: true },
    },
    {
      propertyId: wifiCoverage.id,
      value: { type: "string", value: "140 m² (1,500 ft²)" },
    },
    {
      propertyId: connectedDevices.id,
      value: { type: "string", value: "300+" },
    },
    {
      propertyId: "powerMethodPoe",
      value: { type: "string", value: "PoE+" },
    },
    {
      propertyId: uplink.id,
      value: { type: "string", value: "2.5/1 GbE" },
    },
    {
      propertyId: "radios",
      value: { type: "boolean", value: false },
    },
    // MUST HAVE FOR OVERVIEW SECTION
    {
      propertyId: "extendedRangeMode6Ghz",
      value: { type: "boolean", value: false },
    },
    {
      propertyId: "rfFilteringTechnology",
      value: { type: "boolean", value: false },
    },
    {
      propertyId: "antennaType",
      value: {
        type: "translation",
        value: "antennaType.omnidirectional",
      },
    },
    {
      propertyId: "weatherproofing",
      value: { type: "boolean", value: false },
    },
    {
      propertyId: "redundantRj45Port",
      value: { type: "boolean", value: false },
    },
    {
      propertyId: "wifiMounting",
      value: {
        type: "translation",
        value: "commons.mounting.ceilingWall",
      },
    },
  ],
};
